import { DateTime } from '@ksyos/date-time';
import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { ProcessActivityModification } from '@common/interfaces';
import { getDisplayName } from '@common/utils/getDisplayName';

export function ModificationDetails(props: Readonly<{ modification: ProcessActivityModification }>) {
    return (
        <FormSection>
            <FormGroup label="Reden van annuleren">
                <FormParagraph>{props.modification.reason}</FormParagraph>
            </FormGroup>

            <FormGroup label="Geannuleerd door">
                <FormParagraph>
                    {props.modification.modifierPractitioner?.nameFamily
                        ? getDisplayName(props.modification.modifierPractitioner, false, 'initialsFamilyName')
                        : null}
                </FormParagraph>
            </FormGroup>

            <FormGroup label="Geannuleerd op">
                <FormParagraph>
                    {props.modification.modificationDateTime
                        ? `${DateTime.from(props.modification.modificationDateTime).format('DD-MM-YYYY')} om ${DateTime.from(props.modification.modificationDateTime).format('HH:mm')} uur`
                        : null}
                </FormParagraph>
            </FormGroup>
        </FormSection>
    );
}
